// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b67432bc","239":"740c7941","455":"2e6d57ea"}[chunkId] + ".chunk.js";
};